// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2oeYQ","box":"WorkspacesBox_box__3szRe","node":"WorkspacesBox_node__3-1Es"};